import styled from 'styled-components';
import theme from '../utils/theme';

const AcercaDe = styled.div`
    width: 100%;
    height: auto;
    background: ${theme.blanco};
    z-index: 10 !important;

    h2 {
        color: white;
        text-align: center;
    }
`;

const GridOverlay = styled.div`
    position: absolute;
    inset: 0;
    background-size: 40px 40px;
    background-image: 
        linear-gradient(to right, rgba(255, 255, 255, 0.03) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    
    /* Desvanecimiento únicamente horizontal (de izquierda a derecha) */
    mask-image: linear-gradient(
        to right, 
        transparent 0%, 
        #000 15%, 
        #000 85%, 
        transparent 100%
    );
    -webkit-mask-image: linear-gradient(
        to right, 
        transparent 0%, 
        #000 15%, 
        #000 85%, 
        transparent 100%
    );

    pointer-events: none;
`;

const DivTitle = styled.div`
    height: auto;
    background: ${theme.fondoOscuro};
    padding-bottom: 80px !important;
    position: relative;
    overflow: hidden;
`;

const AboutContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 900px;
    padding: 60px 20px !important;
    margin: 0 auto !important;
    position: relative;
    z-index: 2;

    @media screen and (max-width: 800px) {
        width: 85%;
        padding: 40px 20px !important;
    }
`;

const AboutContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
`;

const Title = styled.h2`
    color: ${theme.letraBlanca};
    text-align: center;
    width: 100%;
    font-size: 35px;
    font-family: "Funnel Sans", sans-serif;

    @media screen and (max-width: 800px) {
        padding-top: 0px !important;
    }
`;

const Paragraph = styled.p`
    color: ${theme.letraBlanca};
    text-align: center;
    font-size: 18px;
    line-height: 1.6;
    font-family: "Raleway", sans-serif;
    max-width: 750px;
    margin: 0 auto;
    padding-top: 20px !important;

    @media screen and (max-width: 800px) {
        font-size: 16px;
    }
`;

const ParagraphBold = styled(Paragraph)`
    font-family: "Funnel Sans", sans-serif;
    font-size: 20px;
    margin-top: 15px;
    opacity: 0.95;

    @media screen and (max-width: 800px) {
        font-size: 17px;
    }
`;

const DivConocimientos = styled.div`
    background: transparent;
    width: 85vw;
    max-width: 1200px;
    height: auto;
    margin: -60px auto 0 auto !important;
    position: relative;
    z-index: 15;

    @media screen and (max-width: 1024px) {
        width: 90vw;
        margin-top: 30px !important;
    }
`;

const ColumnsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 2rem;

    @media screen and (max-width: 800px) {
        flex-wrap: wrap;
        flex-direction: column;
    }
`;

const ColumnBox = styled.div`
    border-radius: 12px;
    padding: 35px 30px !important;
    width: 33%;
    background: ${theme.blanco};
    border: 1px solid ${theme.grisFuerte};
    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.08);
    
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 20px 30px -10px rgba(15, 23, 42, 0.15);
    }

    @media screen and (max-width: 800px) {
        width: 85%;
    }

    figure {
        margin: 0 auto 20px auto;
        text-align: center;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        img {
            height: 80px;
            width: auto;
            object-fit: contain;
        }
    }

    p {
        text-align: center;
        line-height: 1.6;
        margin-bottom: 0 !important;
        font-size: 15px;
        color: ${theme.letraClara};
        font-family: "Raleway", sans-serif;
    }
`;

const AboutTitle = styled.h3`
    font-weight: 700;
    color: ${theme.letra};
    text-align: center;
    margin: 15px 0 !important;
    font-family: "Funnel Sans", sans-serif;
    font-size: 20px;

    @media screen and (max-width: 800px) {
        font-size: 22px;
    }
`;

const Espacio = styled.div`
    width: 100%;
    height: 80px;
`;

const TechsContainer = styled.div`
    padding: 10px 20px !important;
`;

const TechsTitle = styled.div`
    font-size: 30px;
    text-align: center;
    font-family: "Funnel Sans", sans-serif;
    font-weight: 600;
    color: ${theme.letra} !important;

    @media screen and (max-width: 1024px) {
        padding-top: 60px !important;
    }
`;

const TechsGrid = styled.div`
    width: 80%;
    margin: 0 auto !important;
    margin-top: 3rem !important;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;

    i {
        font-size: 35px;
        filter: grayscale(100%) brightness(0.8);
        transition: filter 0.3s ease;

        &:hover {
            filter: grayscale(0%) brightness(1);
        }
    }
`;

export {
  AcercaDe,
  DivTitle,
  GridOverlay,
  AboutContainer,
  AboutContent,
  Title,
  Paragraph,
  ParagraphBold,
  DivConocimientos,
  ColumnsContainer,
  ColumnBox,
  AboutTitle,
  Espacio,
  TechsContainer,
  TechsTitle,
  TechsGrid
};